import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveAmoContainer } from "../../components/ActiveAmoContainer/ActiveAmoContainer";

const ActiveAmoScreen = () => {
  return (
    <ScreenLayout>
      <ActiveAmoContainer />
    </ScreenLayout>
  );
};

export default ActiveAmoScreen;
